/**
 * Minimal utility functions for time formatting across the portal.
 */

export const formatTimeToDisplay = (isoStr: string): string => {
  const h24 = parseInt(isoStr.slice(11, 13), 10);
  const min = isoStr.slice(14, 16);
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = h24 % 12 || 12;
  return `${String(h12).padStart(2, "0")}:${min} ${period}`;
};

export const updateIsoTime = (
  isoStr: string,
  hour12: number,
  minute: number,
  period: "AM" | "PM"
): string => {
  const date = isoStr.slice(0, 10);
  const rest = isoStr.slice(16);
  const h24 = period === "AM" ? (hour12 === 12 ? 0 : hour12) : (hour12 === 12 ? 12 : hour12 + 12);
  return `${date}T${String(h24).padStart(2, "0")}:${String(minute).padStart(2, "0")}${rest}`;
};

export const updateIsoDate = (isoStr: string, newDateYMD: string): string => {
  return `${newDateYMD}${isoStr.slice(10)}`;
};
